import { GlobalRole, Section, SectionAccess, SectionRole, SiteAccess, UserIdentity } from './user-identity';
import { Logger, LoggerFactory } from './../logger.service';
import { Injectable } from '@angular/core';

@Injectable()
export class IdentityParserService {
  private readonly logger: Logger;

  constructor(loggerFactory: LoggerFactory) {
    this.logger = loggerFactory.get('IdentityParser');
  }

  public transformToIdentity(unmanaged: any): UserIdentity | undefined {
    if (!unmanaged) {
      return undefined;
    }

    const identity = new UserIdentity();

    const sectionNames = Object.keys(Section)
      .map((k) => Section[k])
      .filter((v) => typeof v === 'string') as string[];
    const sectionRoleNames = Object.keys(SectionRole)
      .map((k) => SectionRole[k])
      .filter((v) => typeof v === 'string') as string[];
    sectionNames.forEach((sectionName) => {
      sectionRoleNames.forEach((roleName) => {
        const claimName = `${sectionName.toLowerCase()}_${roleName.toLowerCase()}`;
        if (unmanaged[claimName]) {
          const claimedSites = this.parseAsAnNumberArray(unmanaged[claimName]);
          claimedSites.forEach((claimedSiteId) => {
            const claim = identity.getSiteAccess(claimedSiteId);
            const toAdd = new SectionAccess(Section[sectionName], SectionRole[roleName]);
            if (!claim) {
              identity.sites.push(new SiteAccess(claimedSiteId, [toAdd]));
            } else {
              claim.sections.push(toAdd);
            }
          });
        }
      });
    });

    const sectionlessSites = unmanaged[ClaimKeys.NoSections] as string;
    if (sectionlessSites) {
      const siteIds = this.parseAsAnNumberArray(sectionlessSites);
      siteIds.forEach((siteId) => {
        identity.sites.push(new SiteAccess(siteId));
      });
    }

    if (unmanaged[ClaimKeys.SiteIds]) {
      identity.siteIds = this.parseAsAnNumberArray(unmanaged[ClaimKeys.SiteIds]);
    }

    identity.email = unmanaged[ClaimKeys.Email];
    identity.isVerified = unmanaged[ClaimKeys.IsVerified];
    identity.isSiteAdmin = unmanaged[ClaimKeys.IsSiteAdmin];
    identity.createdAt = unmanaged[ClaimKeys.CreatedAt];
    identity.issuedAt = unmanaged[ClaimKeys.IssuedAt];

    let siteRole = unmanaged[ClaimKeys.SiteRole] as string;
    if (siteRole) {
      siteRole = siteRole.charAt(0).toUpperCase() + siteRole.slice(1);
      identity.role = GlobalRole[siteRole];
    }

    return identity;
  }

  private parseAsAnNumberArray(s: any): Array<number> {
    if (typeof s === 'number') {
      const list = new Array<number>();
      list.push(s as number);
      return list;
    }
    if (s instanceof Array) {
      return s as Array<number>;
    }
    const array: Array<number> = JSON.parse(s);
    return array;
  }
}

export class ClaimKeys {
  static NoSections = 'noSections';
  static Email = 'email';
  static IsVerified = 'isVerified';
  static IsSiteAdmin = 'isSiteAdmin';
  static SiteRole = 'siteRole';
  static CreatedAt = 'createdAt';
  static SiteIds = 'siteIds';
  static IssuedAt = 'iat';
}
